import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { ModalFullscreen, UIText1, IconButton } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { MoreDetailedContainer } from '../../../../containers/OfferHistory/MoreDetailedContainer';

import * as styles from './styles.css';

interface IModalViewProps {
  isOpened: boolean;
  onClose(): void;
  offersTable: React.ReactElement;
  nearbyHousesInfo?: React.ReactElement;
  filters: React.ReactElement;
  offerFromHistory: React.ReactElement;
  onView(): void;
  title: string;
}

export const FullscreenView: React.FC<IModalViewProps> = ({
  isOpened,
  onClose,
  offersTable,
  nearbyHousesInfo,
  filters,
  offerFromHistory,
  onView,
  title,
}) => {
  return (
    <ModalFullscreen open={isOpened} onClose={onClose}>
      <ActionAfterViewObserver callback={onView} callbackDelay={1500} wrapper={false}>
        <div className={styles['container']} data-testid="offers_history_fullscreen_view">
          <header className={styles['header']}>
            <UIText1 fontWeight="bold">{title}</UIText1>
            <IconButton icon={<IconActionClose16 />} onClick={onClose} data-testid="offers_history_fullscreen_close" />
          </header>
          <div className={styles['main']}>
            <div className={styles['listing']}>
              {filters}
              {nearbyHousesInfo}
              <MoreDetailedContainer />
              <div className={styles['table']}>{offersTable}</div>
            </div>
            <div className={styles['offer']}>{offerFromHistory}</div>
          </div>
        </div>
      </ActionAfterViewObserver>
    </ModalFullscreen>
  );
};
